var FormatFactory = require('../../../factory/formats');

module.exports = {
  showResizeMenu: $.noop,
  doResizeEvent: $.noop,
  showResizeEvent: $.noop,

  render: function (format, groups) {
    var units = _.uniq(_.pluck(_.flatten(_.pluck(groups, 'data')), 'unit'));
    format = format || FormatFactory.getCurrentSize();
    format.unit = format.unit || 'px';

    this.editor.canvas.runExtensions('updateUnits', format.unit);

    this.$el.html(this.template({
      format: format,
      groups: groups,
      units: units
    }));

    this.$el.find('.btn.resize').parent().hide();
    this.$el.find('.page-size').css('border-right', 'none');

    INKIVE.Helpers.initTooltips(this.$el);
    this.trigger('render');
  }
};
